import { render, staticRenderFns } from "./user-role.vue?vue&type=template&id=7bfd9b12&scoped=true"
import script from "./user-role.vue?vue&type=script&lang=js"
export * from "./user-role.vue?vue&type=script&lang=js"
import style0 from "./user-role.vue?vue&type=style&index=0&id=7bfd9b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd9b12",
  null
  
)

export default component.exports